import { List, Map } from 'immutable'
import { combineReducers } from 'redux-immutable'
import { handleActions, combineActions } from 'redux-actions'
import * as actions from './actions'
import { Attrib } from './models'

const attribs = handleActions({
  [combineActions(
    actions.fetchAccountAttribsPending,
  )]: (state) => state.set('loading', true),

  [combineActions(
    actions.fetchAccountAttribsCancelled,
    actions.fetchAccountAttribsFailed,
    actions.fetchAccountAttribsSuccess
  )]: (state) => state.set('loading', false),

  [actions.fetchAccountAttribsSuccess]: (state, action) => {
    return state.set('attribs', List(action.payload.map(attrib => new Attrib(attrib))))
  }
}, Map())

const segments = handleActions({
  [combineActions(
    actions.fetchAccountSegmentsPending
  )]: (state) => state.set('loading', true),

  [combineActions(
    actions.fetchAccountSegmentsCancelled,
    actions.fetchAccountSegmentsFailed,
    actions.fetchAccountSegmentsSuccess
  )]: (state) => state.set('loading', false),

  [actions.fetchAccountSegmentsSuccess]: (state, action) => {
    return state.set('accountSegments', action.payload)
  }
}, Map())

export default combineReducers({ attribs, segments })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/account/reducer.js